export const CREATE_CLIENT = "auth/create";
export const CREATE_GOOGLE_CLIENT = "auth/create-google-account";
export const LOGIN_CLIENT = "auth/login";
export const LOGIN_GOOGLE_CLIENT = "auth/login-google-account";